import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@app/utils";
import { useCalculator } from "../use-calculator";

export const CardList = () => {
  const { t } = useTranslation("calculator");
  const { data, value, fees, formula } = useCalculator();

  return (
    <div className="content text-regular">
      <div className="flex-grow">
        <div className="mb-11 text-primary-content">
          <div className="mb-6 flex justify-between">
            <p>{t("expected_return")}</p>
            <p>{value ? fees.alpian.interest.toFixed(2) : 0}%</p>
          </div>

          <div className="flex justify-between">
            <p>{t("overcost_pa_with_bank_xy")}*</p>
            <p>{value ? fees.other.overcost.toFixed(2) : 0}%</p>
          </div>
        </div>

        <div>
          <p className="mb-6 text-primary-content">
            {t("missing_performance")}{" "}
            {formula === "managed" ? t("discretionary") : t("advisory")}
          </p>
          {data.map((item) => (
            <div
              key={item.year}
              className="mb-2.5 flex justify-between border-b border-divider pb-2.5 text-base-400 last:mb-0 last:border-0 last:pb-0"
            >
              <p className="mb-0">{t("after_x_years", { years: item.year })}</p>
              <p className="mb-0">{formatCurrency(item.difference)}</p>
            </div>
          ))}
        </div>
      </div>

      <p
        className={classNames(
          "mb-0 mt-20 text-extra-small text-base-400",
          "[&_a]:duration-300 [&_a]:hover:text-primary-content",
        )}
        dangerouslySetInnerHTML={{ __html: `*${t(`footertext_${formula}`)}` }}
      />
    </div>
  );
};
